import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'

import {
  MESSAGE_STR_TYPE_CONFIRMATION,
  MESSAGE_STR_TYPE_WELCOME
} from 'Constants/index'
import { notifyParent } from 'Helpers/notifyParent'
import { getRouteForFirstEntity } from 'Pages/OverviewMessage/recoil/actions/actions'
import {
  messageState,
  notificationState
} from 'Pages/OverviewMessage/recoil/state/message'
import {
  BADGE_KIND_OUTLINE,
  BADGE_TYPE_DEFAULT,
  Badge,
  Flex,
  FlexItem,
  LINK_VARIANT_EXTRALIGHT,
  Link,
  Panel,
  TEXT_VARIANT_BOLD,
  Text,
  Toggle,
  TooltipUtils
} from 'mailup-web-components'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { modalConfirmChangeDefaultMessageState } from '../recoil/state/modal'

import ToggleTooltipContent from 'Pages/OverviewMessage/BoxNotification/ToggleTooltipContent'

const BoxNotification = () => {
  const { id } = useParams()
  const intl = useIntl()

  const [
    { notificationEnable, activeMessage },
    setNotification
  ] = useRecoilState(notificationState)
  const {
    messageType,
    linkedForms,
    isUsed,
    subject,
    linkedEntities
  } = useRecoilValue(messageState)

  const setModalChangeDefault = useSetRecoilState(
    modalConfirmChangeDefaultMessageState
  )

  const handleChangeToggle = e => {
    const toggleState = e.target.checked
    setNotification(prev => ({
      ...prev,
      notificationEnable: toggleState
    }))
  }

  const setDefaultMessage = async () => {
    setModalChangeDefault(prev => ({
      ...prev,
      show: true,
      message: { id, name: subject }
    }))
  }

  const redirectToMessageTypeList = async () => {
    if (messageType === MESSAGE_STR_TYPE_CONFIRMATION) {
      notifyParent('redirectMainFrame', [
        `databasebuilding_app_redirector.aspx?r=${encodeURIComponent(
          '/databasebuilding/subscriptions/confirmation/list'
        )}`
      ])
    }
    if (messageType === MESSAGE_STR_TYPE_WELCOME) {
      notifyParent('redirectMainFrame', [
        `databasebuilding_app_redirector.aspx?r=${encodeURIComponent(
          '/databasebuilding/subscriptions/welcome/list'
        )}`
      ])
    }
  }

  const redirectToUsedForm = () => {
    const route = getRouteForFirstEntity(linkedForms)
    notifyParent('redirectMainFrame', [
      `databasebuilding_app_redirector.aspx?r=${encodeURIComponent(route)}`
    ])
  }

  const usedMessageTooltipNotificationInUseID =
    messageType === MESSAGE_STR_TYPE_CONFIRMATION
      ? 'Load.MessageOverview.TooltipNotificationInUse'
      : 'Load.MessageOverview.TooltipNotificationInUseWelcome'

  return (
    <>
      <TooltipUtils
        id='message-usage-tooltip'
        type='light'
        effect='solid'
        className='c-tooltip'
      >
        <ToggleTooltipContent
          messageType={messageType}
          isActiveMessage={activeMessage}
        />
      </TooltipUtils>
      <Panel data-mu-test='overview-message-box-notification'>
        <Flex justifyContent='space-between' alignItems='center'>
          <Text variant={TEXT_VARIANT_BOLD}>
            {intl.formatMessage({
              id: 'Load.SavedEmailWizard.MsgAsNotification'
            })}
          </Text>

          {activeMessage || linkedEntities.length > 0 ? (
            <>
              <FlexItem height='24px' data-for='message-usage-tooltip' data-tip>
                <Toggle
                  checked={notificationEnable}
                  onChange={handleChangeToggle}
                  disabled
                />
              </FlexItem>
            </>
          ) : (
            <FlexItem height='24px'>
              <Toggle
                checked={notificationEnable}
                onChange={handleChangeToggle}
              />
            </FlexItem>
          )}
        </Flex>

        {notificationEnable && (
          <Flex alignItems='center' margin='8px 0 0 0' columnGap='8px'>
            <Text>
              {messageType === MESSAGE_STR_TYPE_WELCOME &&
                intl.formatMessage({
                  id: 'Load.SavedEmailWizard.SendWelcomeMessage'
                })}
              {messageType === MESSAGE_STR_TYPE_CONFIRMATION &&
                intl.formatMessage({
                  id: 'Load.SavedEmailWizard.SendComfirmationMessage'
                })}
            </Text>
            {(messageType === MESSAGE_STR_TYPE_CONFIRMATION ||
              messageType === MESSAGE_STR_TYPE_WELCOME) && (
              <>
                {activeMessage ? (
                  <>
                    <Badge
                      type={BADGE_TYPE_DEFAULT}
                      kind={BADGE_KIND_OUTLINE}
                      text={intl.formatMessage({
                        id: 'Load.MailupCommon.Default'
                      })}
                    />
                    <Link
                      onClick={redirectToMessageTypeList}
                      variant={LINK_VARIANT_EXTRALIGHT}
                    >
                      {intl.formatMessage({
                        id: 'Load.EmailMessageList.ChangeDefault'
                      })}
                    </Link>
                  </>
                ) : (
                  <>
                    <Badge
                      type={BADGE_TYPE_DEFAULT}
                      kind={BADGE_KIND_OUTLINE}
                      text={
                        isUsed
                          ? intl.formatMessage({
                              id: 'Load.MailupCommon.InUse'
                            })
                          : intl.formatMessage({
                              id: 'Load.MailupCommon.NotInUse'
                            })
                      }
                    />
                    {isUsed && linkedForms.length === 1 ? (
                      <Link
                        onClick={redirectToUsedForm}
                        variant={LINK_VARIANT_EXTRALIGHT}
                      >
                        {intl.formatMessage({
                          id: 'Load.EmailMessageList.GoToAssociatedForm'
                        })}
                      </Link>
                    ) : (
                      !isUsed && (
                        <Link
                          onClick={setDefaultMessage}
                          variant={LINK_VARIANT_EXTRALIGHT}
                        >
                          {intl.formatMessage({
                            id: 'Load.EmailMessageList.PutAsDefault'
                          })}
                        </Link>
                      )
                    )}
                  </>
                )}
              </>
            )}
          </Flex>
        )}
      </Panel>
    </>
  )
}

export default BoxNotification
